<div class="flex justify-center" *transloco="let t; read 'customer.implementation-plan'">
  <form [formGroup]="formGroup" class="w-[95%] md:w-2/3 pt-5" *ngIf="powerPlant">
    <psc-section-title
      [title]="t('title')"></psc-section-title>
    <div class="grid gap-5 grid-cols-[2fr_6fr_1fr] md:grid-cols-[3fr_5fr_1fr] text-blue1">

      <div class="text-center font-bold text-xl col-span-3">
        {{t('plan_will_come', {date: '1.5.2024'})}}
      </div>

      <div class="{{lineClass}}"></div>

      <div class="font-bold justify-self-end">{{t('contractor_list.title')}}</div>
      <div class="text-center">{{t('contractor_list.query', { count: maxCompanyCount })}}</div>
      <div>
        <psc-button
          size="small"
          [label]="t('contractor_list.add')"
          [disabled]="selectedContractors.length === maxCompanyCount || contractors.length === 0"
          (buttonClicked)="showAddContractorDialog = true"></psc-button>
      </div>

      <psc-company-table
        class="col-start-2 col-span-2"
        [currency]="powerPlant.price.currency"
        (deleteCompanyClicked)="removeContractor($event)"
        [companies]="selectedContractors"></psc-company-table>

      <div class="{{lineClass}}"></div>

      <div class="font-bold justify-self-end">{{t('bank_list.title')}}</div>
      <div class="text-center">{{t('bank_list.query', { count: maxCompanyCount })}}</div>
      <div>
        <psc-button
          size="small"
          [label]="t('bank_list.add')"
          [disabled]="selectedBanks.length >= maxCompanyCount || banks.length === 0"
          (buttonClicked)="showAddBankDialog = true"></psc-button>
      </div>

      <psc-company-table
        class="col-start-2 col-span-2"
        (deleteCompanyClicked)="removeBank($event)"
        [companies]="selectedBanks"></psc-company-table>

      <psc-button
        class="col-span-3 justify-self-end mt-10"
        [label]="t('save')"
        (buttonClicked)="saveImplementationPlan()"></psc-button>
    </div>
  </form>
  <psc-dialog
    *ngIf="showAddContractorDialog"
    [title]="t('add_contractor.title', { count: maxCompanyCount })"
    (closeClicked)="showAddContractorDialog = false">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <psc-company-card *ngFor="let contractor of contractors" [company]="contractor">
        <div class="flex justify-end">
          <psc-button
            size="small"
            [label]="listIncludes(selectedContractors, contractor) ? t('add_contractor.already_includes') :t('add_contractor.add')"
            [disabled]="selectedContractors.length >= 3 || listIncludes(selectedContractors, contractor)"
            (buttonClicked)="addContractor(contractor)"></psc-button>
        </div>
      </psc-company-card>
    </div>
  </psc-dialog>

  <psc-dialog
    *ngIf="showAddBankDialog"
    [title]="t('add_bank.title', { count: maxCompanyCount })"
    (closeClicked)="showAddBankDialog = false">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <psc-company-card *ngFor="let bank of banks" [company]="bank">
        <div class="flex justify-end">
          <psc-button
            size="small"
            [label]="listIncludes(selectedBanks, bank) ? t('add_bank.already_includes') : t('add_bank.add')"
            [disabled]="selectedBanks.length >= 3 || listIncludes(selectedBanks, bank)"
            (buttonClicked)="addBank(bank)"></psc-button>
        </div>
      </psc-company-card>
    </div>
  </psc-dialog>
</div>
